<template>
  <label :for="inputId" class="mob-checkbox">
    <input
      class="hidden"
      type="checkbox"
      :id="inputId"
      :name="inputName"
      :disabled="disabled"
      :checked="checked"
      @change="toggleCheckbox"
    />
    <span class="checkbox">
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;transform: ;msFilter:;"><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
    </span>
    <span>
      <slot v-if="$slots.default"></slot>
      <template v-else>
        {{ label }}
      </template>
    </span>
  </label>
</template>

<script>
export default {
  name: "MobCheckbox",
  props: {
    label: String,
    disabled: Boolean,
    inputId: {
      type: String,
      default: () => `mob-checkbox-${Math.random().toString(36).substring(7)}`,
    },
    inputName: String,
    value: Boolean,
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    toggleCheckbox(event) {
      this.checked = event.target.checked;
    },
  },
};
</script>

<style>
.mob-checkbox {
  @apply inline-flex gap-2 text-left;
}

.mob-checkbox input + .checkbox {
  @apply w-6 h-6 rounded border border-neutral-300 text-transparent flex items-center justify-center cursor-pointer transition-colors;
  content: "";
}

.mob-checkbox input:checked + .checkbox {
  @apply bg-blue-500 border-blue-500 text-white;
  content: "";
}
</style>
